import { useGetCommonFreightModes } from "api/queries/common/useGetCommonFreightModes";
import { useGetCurrencies } from "api/queries/common/useGetCurrencies";

export default function usePaymentLocationQueries() {
  const { data: currenciesData }: any = useGetCurrencies({
    select: (data) =>
      data.map((currency) => ({
        value: currency.code,
        label: currency.name,
      })) as any,
  });
  const { data: freightModesData }: any = useGetCommonFreightModes({
    options: {
      select: (data) =>
        data.map((freightMode) => ({
          value: freightMode.key,
          label: freightMode.translated_value ?? freightMode.value,
        })) as any,
    },
    includeCustom: false,
  });

  return { currenciesData, freightModesData };
}
